import React from 'react'
import { InlineCode } from './s'

export const accentuate = chunks => <em><strong>{chunks}</strong></em>
export const codify = chunks => <InlineCode>{chunks}</InlineCode>